/**
 * Fortschrittsring klein (Musterkatalog M-011 AD5, Design-Guide `fortschritt.md`): ein Wert 0–100 als Ring neben der
 * Zahl, z. B. in der Eigenschaftszeile „Fortschritt“. Die Zahl steht immer im Text daneben (Aufrufer), der Ring allein
 * trägt keine Aussage. Der Strich kommt aus SVG-Attributen (`stroke-dashoffset`), nie aus `style=`.
 */
export type RingGroesse = "klein" | "mittel";

const RING_KLASSE: Record<RingGroesse, string> = {
  klein: "relative inline-block size-5 shrink-0",
  mittel: "relative inline-block size-8 shrink-0",
};

export function Fortschrittsring({
  prozent,
  label,
  groesse = "klein",
  wertText,
}: {
  prozent: number;
  label: string;
  groesse?: RingGroesse;
  /** Gesprochener Stand statt der Prozentzahl (z. B. „2 von 4“ bei einem Zähler), als `aria-valuetext`. */
  wertText?: string;
}) {
  const wert = Math.max(0, Math.min(100, Math.round(prozent)));
  return (
    <>
      {/* Preline: component/progress/progress-circular-progress */}
      <span className={RING_KLASSE[groesse]} role="progressbar" aria-label={label} aria-valuenow={wert} aria-valuetext={wertText} aria-valuemin={0} aria-valuemax={100}>
        <svg className="size-full -rotate-90" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="18" cy="18" r="16" fill="none" className="stroke-current text-primary-100" strokeWidth="4" />
          <circle
            cx="18"
            cy="18"
            r="16"
            fill="none"
            className="stroke-current text-primary"
            strokeWidth="4"
            pathLength={100}
            strokeDasharray="100"
            strokeDashoffset={100 - wert}
            strokeLinecap="round"
          />
        </svg>
      </span>
    </>
  );
}
